import { render } from "./Detalle.vue?vue&type=template&id=2befd556&scoped=true"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"

import "./Detalle.vue?vue&type=style&index=0&id=2befd556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2befd556"]])

export default __exports__